(function(){
 // hero slider
 document.querySelectorAll('[data-slider]').forEach(function(el){
  var s=el.querySelectorAll('.hm-slide'),d=el.querySelectorAll('[data-dot]'),i=0,t;
  function go(n){s[i].classList.remove('is-active');d[i]&&d[i].classList.remove('is-active');i=(n+s.length)%s.length;s[i].classList.add('is-active');d[i]&&d[i].classList.add('is-active')}
  function run(){clearInterval(t);if(s.length>1)t=setInterval(function(){go(i+1)},+el.dataset.speed||5000)}
  d.forEach(function(b){b.addEventListener('click',function(){go(+b.dataset.dot);run()})});run();
 });
 // countdown
 document.querySelectorAll('[data-countdown]').forEach(function(el){
  var end=new Date(el.dataset.countdown).getTime();if(isNaN(end))return;
  function pad(n){return String(n).padStart(2,'0')}
  function tick(){var r=Math.max(0,end-Date.now())/1000;
   el.querySelector('[data-d]').textContent=pad(Math.floor(r/86400));el.querySelector('[data-h]').textContent=pad(Math.floor(r%86400/3600));
   el.querySelector('[data-m]').textContent=pad(Math.floor(r%3600/60));el.querySelector('[data-s]').textContent=pad(Math.floor(r%60))}
  tick();setInterval(tick,1000);
 });
 // popup
 var p=document.querySelector('[data-popup]');
 if(p){var key='hamanu_popup_off',off=false;try{off=localStorage.getItem(key)}catch(e){}
  if(!off)setTimeout(function(){p.hidden=false},+p.dataset.delay||3000);
  p.querySelector('[data-popup-close]').addEventListener('click',function(){
   try{if(p.querySelector('[data-popup-never]').checked)localStorage.setItem(key,'1')}catch(e){}p.hidden=true});}
 // mobile menu
 var mt=document.querySelector('[data-menu-toggle]'),mn=document.querySelector('[data-menu]');
 mt&&mt.addEventListener('click',function(){mn.classList.toggle('is-open')});
 // product page
 var main=document.getElementById('MainImg');
 document.querySelectorAll('[data-thumb]').forEach(function(b){b.addEventListener('click',function(){
  document.querySelectorAll('[data-thumb]').forEach(function(x){x.classList.remove('is-active')});b.classList.add('is-active');
  if(main){main.src=b.dataset.thumb;main.removeAttribute('srcset')}})});
 document.querySelectorAll('[data-q]').forEach(function(b){b.addEventListener('click',function(){
  var i=b.parentNode.querySelector('input');i.value=Math.max(1,(+i.value||1)+(+b.dataset.q))})});
 var tabs=document.querySelector('[data-tabs]');
 tabs&&tabs.querySelectorAll('[data-tab]').forEach(function(b){b.addEventListener('click',function(){
  tabs.querySelectorAll('.is-on').forEach(function(x){x.classList.remove('is-on')});
  b.classList.add('is-on');tabs.querySelector('[data-pane="'+b.dataset.tab+'"]').classList.add('is-on')})});
 // sticky add-to-cart bar
 var st=document.querySelector('[data-sticky]'),f=document.getElementById('pdp-form');
 if(st&&f&&'IntersectionObserver' in window){new IntersectionObserver(function(e){st.classList.toggle('is-on',!e[0].isIntersecting&&e[0].boundingClientRect.top<0)}).observe(f)}
})();
(function(){
 // trending auto-scroll
 var tr=document.querySelector('[data-trend]');
 if(tr&&tr.children.length>3){setInterval(function(){
  if(tr.matches(':hover'))return;
  if(tr.scrollLeft+tr.clientWidth>=tr.scrollWidth-4)tr.scrollLeft=0;else tr.scrollLeft+=290}, 3000)}
 // product tabs
 document.querySelectorAll('[data-tabs-wrap]').forEach(function(w){
  w.querySelectorAll('[data-ptab]').forEach(function(b){b.addEventListener('click',function(){
   w.querySelectorAll('.is-on').forEach(function(x){x.classList.remove('is-on')});
   b.classList.add('is-on');w.querySelector('[data-ppane="'+b.dataset.ptab+'"]').classList.add('is-on')})})});
 // side widgets
 var up=document.querySelector('[data-totop]');
 if(up){window.addEventListener('scroll',function(){up.classList.toggle('is-on',window.scrollY>400)});
  up.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'})})}
 var fs=document.querySelector('[data-focus-search]');
 fs&&fs.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'});var i=document.querySelector('.hm-search input');i&&setTimeout(function(){i.focus()},400)});
 var dk=document.querySelector('[data-dark-toggle]');
 try{if(localStorage.getItem('hm_dark')==='1')document.body.classList.add('hm-dark')}catch(e){}
 dk&&dk.addEventListener('click',function(){var on=document.body.classList.toggle('hm-dark');try{localStorage.setItem('hm_dark',on?'1':'0')}catch(e){}});
})();
